import { createSlice } from "@reduxjs/toolkit";
import {
  getUsers,
  addNewUser,
  addNewEmployee,
  updateUser,
  updateEmployee,
  heartbeatUser,
  deleteUser,
  changePassword,
  uploadPDFs,
  uploadPDFsTransport,
  getFiles,
  getFilesTransport,
  deleteFile,
  updateFiles,
  getExchangeRates,
} from "./thunk";

export const initialState = {
  crmusers: [],
  error: {},
  isPasswordCorrect: null,

  files: [],
  filesLoading: false,
  filesError: null,

  exchangeRates: [],
  errorExchangeRates: {},
  isExchangeRatesSuccess: false,
};

const crmSlice = createSlice({
  name: "crm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.crmusers = Array.isArray(action.payload) ? action.payload : [];
      state.isUserFailed = false;
      state.isUserSuccess = true;
    });

    builder.addCase(getUsers.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isUserFailed = true;
      state.isUserSuccess = false;
    });

    builder.addCase(addNewUser.fulfilled, (state, action) => {
      state.crmusers.push(action.payload);
      state.isUserAdd = true;
      state.isUserAddFail = false;
    });

    builder.addCase(addNewUser.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isUserAdd = false;
      state.isUserAddFail = true;
    });

    builder.addCase(addNewEmployee.fulfilled, (state, action) => {
      state.crmusers.push(action.payload);
      state.isUserAdd = true;
      state.isUserAddFail = false;
    });

    builder.addCase(addNewEmployee.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isUserAdd = false;
      state.isUserAddFail = true;
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.crmusers = state.crmusers.map((contact) =>
        contact._id.toString() === action.payload._id.toString()
          ? { ...contact, ...action.payload }
          : contact
      );
      state.isUserUpdate = true;
      state.isUserUpdateFail = false;
    });

    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isUserUpdate = false;
      state.isUserUpdateFail = true;
    });

    builder.addCase(updateEmployee.fulfilled, (state, action) => {
      state.crmusers = state.crmusers.map((contact) =>
        contact._id.toString() === action.payload._id.toString()
          ? { ...contact, ...action.payload }
          : contact
      );
      state.isUserUpdate = true;
      state.isUserUpdateFail = false;
    });

    builder.addCase(updateEmployee.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isUserUpdate = false;
      state.isUserUpdateFail = true;
    });

    builder.addCase(heartbeatUser.fulfilled, (state, action) => {
      state.crmusers = state.crmusers.map((contact) =>
        contact._id.toString() === action.payload._id.toString()
          ? { ...contact, ...action.payload }
          : contact
      );
      state.isUserUpdate = true;
      state.isUserUpdateFail = false;
    });

    builder.addCase(heartbeatUser.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isUserUpdate = false;
      state.isUserUpdateFail = true;
    });

    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.crmusers = (state.crmusers || []).filter(
        (contact) =>
          contact._id.toString() !== action.payload.contact.toString()
      );
      state.isUserDelete = true;
      state.isUserDeleteFail = false;
    });

    builder.addCase(deleteUser.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isUserDelete = false;
      state.isUserDeleteFail = true;
    });

    builder.addCase(changePassword.fulfilled, (state, action) => {
      state.crmusers = state.crmusers.map((contact) =>
        contact._id.toString() === action.payload._id.toString()
          ? { ...contact, ...action.payload }
          : contact
      );
      state.isUserUpdate = true;
      state.isUserUpdateFail = false;
      state.isPasswordCorrect = true;
    });

    builder.addCase(changePassword.rejected, (state, action) => {
      state.error = action.payload || null;
      state.isUserUpdate = false;
      state.isUserUpdateFail = true;
      state.isPasswordCorrect = false;
    });

    builder
      // Upload PDFs
      .addCase(uploadPDFs.pending, (state) => {
        state.filesLoading = true;
        state.filesError = null;
      })
      .addCase(uploadPDFs.fulfilled, (state, action) => {
        state.filesLoading = false;
        state.files = [...state.files, ...action.payload];
      })
      .addCase(uploadPDFs.rejected, (state, action) => {
        state.filesLoading = false;
        state.filesError = action.payload;
      })

      // Upload PDFs Transport
      .addCase(uploadPDFsTransport.pending, (state) => {
        state.filesLoading = true;
        state.filesError = null;
      })
      .addCase(uploadPDFsTransport.fulfilled, (state, action) => {
        state.filesLoading = false;
        state.files = [...state.files, ...action.payload];
      })
      .addCase(uploadPDFsTransport.rejected, (state, action) => {
        state.filesLoading = false;
        state.filesError = action.payload;
      })

      // Fetch PDFs
      .addCase(getFiles.pending, (state) => {
        state.filesLoading = true;
        state.filesError = null;
      })
      .addCase(getFiles.fulfilled, (state, action) => {
        state.filesLoading = false;
        state.files = action.payload;
      })
      .addCase(getFiles.rejected, (state, action) => {
        state.filesLoading = false;
        state.filesError = action.payload;
      })

      // Fetch PDFs Transport
      .addCase(getFilesTransport.pending, (state) => {
        state.filesLoading = true;
        state.filesError = null;
      })
      .addCase(getFilesTransport.fulfilled, (state, action) => {
        state.filesLoading = false;
        state.files = action.payload;
      })
      .addCase(getFilesTransport.rejected, (state, action) => {
        state.filesLoading = false;
        state.filesError = action.payload;
      });

    builder.addCase(updateFiles.fulfilled, (state, action) => {
      state.files.push(action.payload);
      state.isFileUpdate = true;
      state.isFileUpdateFail = false;
    });

    builder.addCase(updateFiles.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isFileUpdate = false;
      state.isFileUpdateFail = true;
    });

    builder.addCase(deleteFile.fulfilled, (state, action) => {
      const deletedId = action.payload?.fileId;
      if (!deletedId) return;

      state.files = (state.files || []).filter(
        (file) => file._id && file._id.toString() !== deletedId.toString()
      );
      state.isFileDelete = true;
      state.isFileDeleteFail = false;
    });

    builder.addCase(deleteFile.rejected, (state, action) => {
      state.error = action.payload || action.error.message || null;
      state.isFileDelete = false;
      state.isFileDeleteFail = true;
    });

    builder.addCase(getExchangeRates.fulfilled, (state, action) => {
      state.exchangeRates = action.payload;
      state.isExchangeRatesFailed = false;
      state.isExchangeRatesSuccess = true;
    });

    builder.addCase(getExchangeRates.rejected, (state, action) => {
      state.errorExchangeRates = action.payload?.error ?? action.error?.message ?? null;
      state.isExchangeRatesFailed = true;
      state.isExchangeRatesSuccess = false;
    });
  },
});

export default crmSlice.reducer;
